module.exports = __webpack_public_path__ + "img/sell-mobile.ca8a4419.svg";